import { request } from "@/api";
import cookies from 'js-cookie';

const ENDPOINT_ACHIEVEGOAL_DETAIL = 'AchieveGoal/Detail';

export default {
    namespaced: true,
    state: {
        bigDataGuideResult: null
    },
    actions: {
        async getDetail ({ state }, payload) {
            const resp = await request(ENDPOINT_ACHIEVEGOAL_DETAIL, "post", {
                achieveGoalKey: payload.achieveGoalKey,
                datetimes: payload.endDatetimes,
                uId: cookies.get('UID'),
                appType: cookies.get('AppType'),
                appVersion: cookies.get('AppVersion'),
                languageCode: cookies.get('LanguageCode'),
                countryCode: cookies.get('CountryCode'),
                utcInterval: cookies.get('UTCInterval'),
                whereToUseCode: cookies.get('WhereToUseCode') === undefined ? null : cookies.get('WhereToUseCode')
            });
            if (resp.data !== undefined && resp.data !== null) {
                console.log(resp.data);
                state.bigDataGuideResult = resp.data
            }
        }
    },
    mutations: {
    }
}